import {
  ContactsOutlined,
  CheckSquareOutlined,
  DollarCircleOutlined,
  FileDoneOutlined,
  FundOutlined,
  ShoppingOutlined,
  MessageOutlined,
  SolutionOutlined,
  MenuUnfoldOutlined,
  HistoryOutlined,
  SettingOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { AdminLayout } from "layouts/AdminLayout";
import React from "react";
import { NotFoundPage } from "views/404/NotFoundPage";
import { ConfigurationPage } from "views/Configuration/ConfigurationPage";
import { ConnectionErrorPage } from "views/ConnectionError/ConnectionErrorPage";
import LoginPage from "views/Login/LoginPage";
import { ProfilePage } from "views/Profile/ProfilePage";
import { CommissionPage } from "views/Commission/CommissionPage";
import { CustomerPage } from "views/Customer/CustomerPage";
import { OpportunityFormPage } from "views/Opportunity/OpportunityFormPage";
import { OpportunityPage } from "views/Opportunity/OpportunityPage";
import { QuotePage } from "views/Opportunity/QuotePage";
import { OrderPage } from "views/Order/OrderPage";
import { FeedbackPage } from "views/Feedback/FeedbackPage";
import { LeadPage } from "views/Lead/LeadPage";
import { LogPage } from "views/Log/LogPage";
import { RolePage } from "views/Role/RolePage";
import { StaffPage } from "views/Staff/StaffPage";
import { TodoPage } from "views/Todo/TodoPage";

export interface AppRoute {
  path?: string;
  index?: boolean;
  element?: React.ReactNode;
  name?: string;
  title?: string;
  children?: AppRoute[];
  icon?: React.ReactNode;
  breadcrumb?: string;
  isAccess?: boolean;
  hidden?: boolean;
  checkIsDev?: boolean;
  isPublic?: boolean; // luôn truy cập được, không cần permission
  description?: string;
}

export type Route = AppRoute;

export const adminRoutes: AppRoute[] = [
  {
    title: "Lead",
    icon: <SolutionOutlined />,
    name: "lead",
    element: <LeadPage title="Lead" />,
    path: "/lead",
  },
  {
    title: "Khách hàng",
    icon: <ContactsOutlined />,
    name: "customer",
    element: <CustomerPage title="Khách hàng" />,
    path: "/customer",
  },
  {
    title: "Cơ hội",
    icon: <FundOutlined />,
    name: "opportunity",
    element: <OpportunityPage title="Cơ hội" />,
    path: "/opportunity",
  },
  {
    title: "Báo giá",
    icon: <FileDoneOutlined />,
    name: "quote",
    element: <QuotePage title="Báo giá" />,
    path: "/quote",
  },
  {
    title: "Đơn hàng",
    icon: <ShoppingOutlined />,
    name: "order",
    element: <OrderPage title="Đơn hàng" />,
    path: "/order",
  },
  {
    title: "Phản hồi",
    icon: <MessageOutlined />,
    name: "feedback",
    element: <FeedbackPage title="Phản hồi" />,
    path: "/feedback",
  },
  {
    title: "Hoa hồng SALE",
    icon: <DollarCircleOutlined />,
    name: "commission",
    element: <CommissionPage title="Hoa hồng SALE" />,
    path: "/commission",
  },
  {
    title: "Tạo cơ hội",
    name: "opportunity-create",
    element: <OpportunityFormPage />,
    path: "/opportunity/create",
    hidden: true,
  },
  {
    title: "Chi tiết cơ hội",
    name: "opportunity-detail",
    element: <OpportunityFormPage />,
    path: "/opportunity/:id",
    hidden: true,
  },
  {
    title: "Chi tiết báo giá",
    name: "quote-detail",
    element: <OpportunityFormPage />,
    path: "/quote/:id",
    hidden: true,
  },
  {
    title: "Việc cần làm",
    icon: <CheckSquareOutlined />,
    name: "todo",
    element: <TodoPage title="Việc cần làm" />,
    path: "/todo",
  },
  {
    title: "Nhân viên",
    icon: <TeamOutlined />,
    name: "staff",
    element: <StaffPage title="Nhân viên" />,
    path: "/staff",
  },
  {
    title: "Vai trò",
    icon: <MenuUnfoldOutlined />,
    name: "role",
    element: <RolePage title="Vai trò" />,
    path: "/role",
  },
  {
    title: "Log",
    icon: <HistoryOutlined />,
    name: "log",
    element: <LogPage title="Log" />,
    path: "/log",
  },
  {
    title: "Cấu hình",
    icon: <SettingOutlined />,
    name: "configuration",
    element: <ConfigurationPage title="Cấu hình" />,
    path: "/configuration",
  },
  {
    title: "Cá nhân",
    icon: <UserOutlined />,
    path: "/profile",
    name: "permission",
    element: <ProfilePage title="Cá nhân" />,
    isPublic: true,
  },
];

const routes: AppRoute[] = [
  {
    path: "/",
    element: <AdminLayout />,
    children: adminRoutes,
  },
  {
    path: "/login",
    element: <LoginPage title="Đăng nhập" />,
  },
  {
    path: "/connection-error",
    element: <ConnectionErrorPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export { routes };
